<template>
  <div class="page-content">
    <div class="page-box">
      <div class="page-box-content">
        <Row type="flex" justify="space-between">
          <Col>
            <i-form inline>
              <FormItem>
                <Select v-model="where.type" :placeholder="$t('name.user_log.type')">
                  <Option v-for="(item, key) in $t('name.user_log.type_text')" :value="key" :key="key">{{ item }}</Option>
                </Select>
              </FormItem>
              <FormItem>
                <Select v-model="where.money" :placeholder="$t('name.user_log.money_type')">
                  <Option v-for="(item, key) in $t('name.user_log.money_type_text')" :value="key" :key="key">{{ item }}</Option>
                </Select>
              </FormItem>
              <FormItem>
                <DatePicker type="daterange" placement="bottom-start" :placeholder="$t('name.user_log.created_at')" v-model="daterange" @on-change="onTime" :clearable="false" />
              </FormItem>
              <FormItem>
                <Button type="primary" icon="md-search" @click="search">{{ $t('name.search') }}</Button>
              </FormItem>
            </i-form>
          </Col>
          <Col>
            <div class="money">{{ user.money | money }}</div>
            <Button type="success" icon="md-card" @click="$refs.pay.open()" style="float:right">{{ $t('name.user_log.pay.title') }}</Button>
          </Col>
        </Row>
        <Table ref="table" :list="list" />
        <div class="page-box-content" style="text-align:center">
          <Page 
            :current.sync="where.page" 
            :total="total" 
            :page-size="size" 
            @on-change="getData" 
            show-total 
            show-elevator 
          />
        </div>
      </div>
    </div>
    <Pay ref="pay" @get="getData" />
  </div>
</template>
<script>
import Table from './table'
import Pay from './pay'
import { log } from '@/api/user';
import { info } from '@/api/auth';

export default {
  components:{
    Table,
    Pay
  },
  data() {
    return {
      user: {},
      list: [],
      total: 0,
      size: 0,
      where: {
        page: 1,
        time: null,
        type: null,
        money: null
      },
      daterange: null
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      log(this.where).then(res => {
        this.list = res.data
        this.where.page = res.current_page
        this.total = res.total
        this.size = res.per_page
      })
      // 用户最新信息
      info().then(res => {
        this.user = res
      })
    },

    // 搜索
    search() {
      this.where.page = 1
      this.getData()
    },
    
    // 选择时间
    onTime() {
      this.where.time = [this.daterange[0].getTime() / 1000, this.daterange[1].getTime() / 1000 + (60 * 60 * 24)]
    }
  },
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';
  
  .money{
      font-size: 14px;
      line-height: 30px;
      color: @color;
      padding: 0 15px;
      margin-left: 15px;
      border: 1px @color solid;
      border-radius: 5px;
      float: right;
    }
</style>